import React, { useEffect, useState, useContext, useRef }from 'react';
import   './SearcResult.css';
import axios from 'axios';
import { Swiper, SwiperSlide} from 'swiper/react';
import { TemplateContext } from '../../contexts/SiteSettingsProvider';
 
import ReactPaginate from 'react-paginate';
import { Spinner } from "react-bootstrap";
 
import SkeletonProperty from '../SkeletonProperty/SkeletonProperty';
 
import PropertyItem from 'components/SearchResult/PropertyItem/PropertyItem';
import useHover from 'utils/useHover';
import 'react-loading-skeleton/dist/skeleton.css'

import 'swiper/css';
import 'swiper/css/lazy';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
 
 

const SearchResult = ({ transferDataToMap, enableImageScrollParam, displayMode, params, setParams, setLoadingStatus   }) => {
  const lang = useContext(TemplateContext);
  const [results, setResults] = useState([]);
  const [linkParams, setLinkParams] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [dictionary, setDictionary] = useState(0);
  
  const [isFetching, setFetching] = useState(false);
  const [gridClasses, setGridClasses] = useState('tw-grid sm:tw-grid-cols-2  xl:tw-grid-cols-2 tw-gap-4');
  const [total, setTotal] = useState(0);
  const [messageText, setMessageText] = useState('');
  const [enableSlider, setEnableSlider] = useState();
  // Tracks the last query we actually requested, so identical param updates
  // (filter defaults, lang, etc. all settling on load) don't fire the same
  // search 2-3 times.
  const lastFetchedRef = useRef(null);
  // Holds the in-flight request controller. When a newer search starts we abort
  // the previous one, so a slow earlier response can never land last and
  // overwrite the results with a stale/different search (the cause of the
  // "default sort looks broken" symptom when two searches raced).
  const abortRef = useRef(null);

  let domain = process.env.REACT_APP_BASE_URL;
  let APIUrl = "apis/searchproperties";

  useEffect(() => {
    setEnableSlider(enableImageScrollParam);
  }, [enableImageScrollParam]);
 
  useEffect(() => {
    setPageCount(Math.ceil(total / 20));
  }, [total]);

  useEffect(() => {
    if (displayMode === 'map') {
      setGridClasses("tw-grid sm:tw-grid-cols-1 tw-grid-cols-1 tw-gap-4")
    }
    if (displayMode === 'fullWidth') {
      setGridClasses("tw-grid  tw-grid-cols-1 tw-gap-4")
    }
  }, [displayMode]);

  function handlePageClick(e) {
    var panel = document.getElementById("SortPanel");

    if (panel) {
      var SortPanel = panel.offsetTop;
      window.scrollTo(0, 260);
    }


    setTimeout(function () {
      setParams({ ...params, Show: "20", Page: e.selected + 1, clearcache: false });
    }, 100)
  }
  
  useEffect(() => {

    setLoadingStatus(true);

 
     
    if (Object.keys(params).length === 0 && params.constructor === Object) {
      return;
    }
    params.Show = 21;

    if (linkParams.length === 0) {
      const currentUrl = new URL(window.location.href);
      const searchParams = new URLSearchParams(currentUrl.search);

      for (const [key, value] of searchParams) {
        // Old/bookmarked URLs can carry literal "undefined"/"null" strings and
        // Currency=0 (pre-cleanup serialisation). Don't copy those into the
        // request params - they'd be sent to the API as real values.
        if (value === 'undefined' || value === 'null' || (key === 'Currency' && value === '0')) {
          continue;
        }
        params[key] = value;
      }
    }

    if (params && !params.hasOwnProperty('SortDirection') && !params.hasOwnProperty('Sort')) {
      params.SortDirection = 'asc';
      params.Sort = 'sleeps';
    }

    if (params.Currency === '0' || !params.Currency || !params.Currency === 0){
      params.Currency = 'GBP';
    }
 
    
    // Skip the request if the params are identical to the last one we fetched.
    // Several effects can set the same params during load, which previously
    // fired 2-3 duplicate searchproperties calls.
    const fetchKey = new URLSearchParams(params).toString();
    if (fetchKey === lastFetchedRef.current) {
      setLoadingStatus(false);
    } else {
      lastFetchedRef.current = fetchKey;
      setResults([]);
      setFetching(false);
      setMessageText("");

      // Cancel any request still in flight before starting this one, then track
      // this one so a later search can cancel it in turn.
      if (abortRef.current) {
        abortRef.current.abort();
      }
      const controller = new AbortController();
      abortRef.current = controller;

      axios.get(domain + APIUrl, {
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        params: params,
        signal: controller.signal,
      },
      ).then(function (response) {
          // Ignore a response that has been superseded by a newer search.
          if (controller.signal.aborted) { return; }
          // handle success
          transferDataToMap(response.data.Items);
          setResults(response.data.Items);
          setTotal(response.data.Total);
          setDictionary(response.data.Dictionaties);
          if (response.data.Items.length === 0 ){
            setMessageText("Sorry, we can't find anything");
          }
          setTimeout(function () { setFetching(true) }, 150)
        })
        .catch(function (error) {
          // A cancelled request is expected (superseded) - not an error to show.
          if (axios.isCancel(error) || error.code === 'ERR_CANCELED' || controller.signal.aborted) { return; }
          // handle error
          setMessageText(error+' Error');
        })
        .finally(function () {
          // Only clear the spinner for the request that is still current;
          // an aborted/superseded request must not turn loading off while the
          // newer request is still running.
          if (abortRef.current === controller) {
            setLoadingStatus(false);
          }
        });
    }
    
    

    const filteredObject = Object.entries(params)
      .filter(([key]) => ![
        'clearcache',
        'Location',
        'PriceFilterType',
        'Nightly',
        'NightlyPriceRange',
        'WeeklyPriceRange',
        'Currency',
        'Attributes',
        'Show'
      ].includes(key))
      .reduce((obj, [key, value]) => {
        if (key === 'CheckIn' || key === 'CheckOut') {
          if (value) {
            const date = new Date(value);
            obj[key] = date.toLocaleDateString('en-GB', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
          }
        } else if (value !== null && value !== undefined && value !== 'null' && value !== 'undefined') {
          // Skip null-ish values so the property link never carries e.g.
          // `Adults=null`, which the booking form would otherwise read back as
          // the string "null" instead of falling back to a sensible default.
          obj[key] = value;
        }

        return obj;
      }, {});


    const urlString = Object.entries(filteredObject)
      .map(pair => pair.map(encodeURIComponent).join('='))
      .join('&');

    setLinkParams('?'+ urlString);
     
  }, [params])

 
 
  const listItems = results.map((item, index) =>{
    return (
      <PropertyItem key={index} dictionary={dictionary} item={item} index={index} linkParams={linkParams} enableSlider={enableSlider} />
    );
  }
  );

  return (
    <> 
 

      {!isFetching ? <h6>  <Spinner variant="primary" animation="border" size="sm" /> We are looking the best properties for you </h6>
        : <h6>{total} Properties are available  </h6>}

      {(messageText.length > 0) ? <h4>{messageText}</h4> :null}
      <div className={gridClasses}>
        {isFetching || <SkeletonProperty count={20} />}
        {listItems}
      </div>  
  

      {(messageText.length === 0 && total>20) ? <ReactPaginate
        className='pagination tw-mt-5'
        breakLabel="..."
        previousLabel="<"
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={3}
        pageCount={pageCount}
        renderOnZeroPageCount={null}

        pageClassName='page-item'
        pageLinkClassName="page-link"
        previousClassName="page-item "
        nextClassName="page-item"
        previousLinkClassName="page-link"
        nextLinkClassName="page-link"
        
        activeClassName="active tw-cursor-default"
        disabledClassName='disabled'
        breakClassName="page-item"
        breakLinkClassName='page-link'
      />
     : null}

    
  
       
    </>

  );
};


export default SearchResult;